import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface IssueFormServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<IssueFormServiceData>(db, 'issueFormService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
